import { Box, Text, Tooltip } from '@wix/design-system';
import React from 'react';
import { useTranslation } from '../../../hooks/use-translation';
import { useExperiments } from '@wix/wix-experiments-react';
import { getDiscountAmount, getIsDevSale, getIsDiscountTypeIsPercentage, getSaleType, } from '../../../selectors/managedApp';
import { mapSaleTypeToTooltipTitleKey } from '../../../consts';
import css from './discount-label.scss';
export const DiscountLabel = ({ app, isEligibleToFreeTrial }) => {
    const t = useTranslation();
    const { experiments } = useExperiments();
    const isDevSale = getIsDevSale(app);
    const isPercentageDiscount = getIsDiscountTypeIsPercentage(app);
    const wixSaleExperiment = experiments.enabled('specs.app-market.Sale');
    const devSaleExperiment = experiments.enabled('specs.app-market.DeveloperSaleBadge');
    const shouldShowWixSale = wixSaleExperiment && !isDevSale && isPercentageDiscount && !isEligibleToFreeTrial;
    const shouldShowDevSale = devSaleExperiment && isDevSale && isPercentageDiscount && !isEligibleToFreeTrial;
    const percentageValue = getDiscountAmount(app);
    const saleType = getSaleType(app);
    const tooltipTitleKey = mapSaleTypeToTooltipTitleKey[saleType];
    return (shouldShowWixSale || shouldShowDevSale) ? (React.createElement(Tooltip, { inline: true, content: React.createElement(Box, { direction: 'vertical' },
            React.createElement(Text, { weight: 'bold', light: true, size: 'small' }, t(tooltipTitleKey)),
            React.createElement(Text, { light: true, size: 'small' }, t('manage-apps.app-card.discount-label.tooltip.description', {
                discount: percentageValue,
            }))) },
        React.createElement(Box, { width: '45px', align: 'right' },
            React.createElement(Text, { className: `${css.discountLabel} ${shouldShowWixSale ? css.appMarketText : ''}`, ellipsis: true }, t('manage-apps.app-card.discount-label', {
                discount: percentageValue,
            }))))) : null;
};
//# sourceMappingURL=discount-label.js.map